import React from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { isObject } from "core-web/utils/object";
import styled from "theme/libs/styled";
import Badges from "theme/components/productPage/Badges";
import TextStyles from "theme/components/text/TextStyles";

const Wrapper = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    margin-top: 24px;
`;

const CategoryLinks = () => {
    const { t } = useTranslation();
    const productInCategories = useSelector(({ page }) => page.data.product_in_categories, shallowEqual) || [];

    const categories = productInCategories.reduce((allCategories, categoryTree) => {
        if (Array.isArray(categoryTree)) {
            categoryTree.forEach((category) => {
                const { title, permalink } = category || {};
                if (
                    title &&
                    permalink &&
                    allCategories.every((addedCategory) => addedCategory.url !== category.permalink)
                ) {
                    allCategories.push({ label: title, url: permalink });
                }
            });
        } else if (isObject(categoryTree)) {
            const { title, permalink } = categoryTree || {};

            if (title && permalink) {
                allCategories.push({ label: title, url: permalink });
            }
        }

        return allCategories;
    }, []);

    if (!categories.length) {
        return null;
    }

    const uniqueCategories = categories.filter((obj, index) => {
        return index === categories.findIndex((o) => obj.label === o.label);
    });

    return (
        <Wrapper>
            <TextStyles as="h2" textStyles="Myriad Pro/20-100-semibold">
                {t("views.product.headings.categories")}
            </TextStyles>
            <Badges badgesAsLinks shouldBreakSpaces badges={uniqueCategories} gap={["8px", null, null, "16px 8px"]} />
        </Wrapper>
    );
};

export default CategoryLinks;
